import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import parse from 'html-react-parser';

import { VpPromptAnswer } from '@vp-ui';
import { StyledPromptDescription, StyledTableCell } from '@vp-ui/dialogs/VpMediaSubmissionDetailsDialog/styles';

export const VpSubmissionDetailsResponses = ({ responses, mediaLabels, campaignId }) => {
  return (
    <>
      {responses.map((prompt, index) => (
        <TableRow key={`prompt-${index}`}>
          <StyledTableCell>
            {/* Checkbox and rich text elements carry their whole question in the
                description, so that is the fallback when there is no question. */}
            {prompt?.question ? (
              <>
                <div>{prompt.question}</div>
                {prompt?.description && (
                  <StyledPromptDescription>{parse(prompt.description)}</StyledPromptDescription>
                )}
              </>
            ) : (
              prompt?.description && parse(prompt.description)
            )}
          </StyledTableCell>
          <StyledTableCell>
            <VpPromptAnswer prompt={prompt} mediaLabels={mediaLabels} campaignId={campaignId} />
          </StyledTableCell>
        </TableRow>
      ))}
    </>
  );
};

VpSubmissionDetailsResponses.propTypes = {
  responses: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      description: PropTypes.string
    })
  ),
  mediaLabels: PropTypes.shape({}),
  campaignId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default VpSubmissionDetailsResponses;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpSubmissionDetailsResponses.jsx